import { httpClient, getPartnerAwareApiUrl } from "@/providers/dataProvider/dataProvider";

/**
 * Writes the canonical partner branding (colors) to the dedicated partners.branding
 * column via PUT /partners/{id}/branding — the single API write path for branding
 * (ADO #4116 / #5360). NOT configuration.branding, which is being retired (#4758).
 *
 * The body is the branding object itself (e.g. { brand_primary, brand_secondary, ... }).
 * Returns the API's PartnerBrandingResponse.
 */
export const putPartnerBranding = async (
  partnerId: string,
  branding: Record<string, unknown>
): Promise<Record<string, unknown>> => {
  const { json } = await httpClient(`${getPartnerAwareApiUrl()}/partners/${partnerId}/branding`, {
    method: "PUT",
    body: JSON.stringify(branding),
  });
  return json as Record<string, unknown>;
};
